export enum SUBSCRIPTION_ITEM_QUANTITY_EVENT_TYPE {
    SET = 'set',
    INCREMENT = 'increment',
    DECREMENT = 'decrement',
}

export type SubscriptionItemQuantityEvent = {
    id: string;
    created_at: string;
    modified_at: string;
    recorded_at: string;
    quantity: number;
    event_type: SUBSCRIPTION_ITEM_QUANTITY_EVENT_TYPE;
    subscription_item: string;
    tenant: string | null;
};
